import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_SERVICE_OBSERVATIONS](state, data) {
    state.allServiceObservations = data
  },
}
